import React from 'react';
export function RedirectIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11.03a1 1 0 00-1 1l-.01 5.715a1.288 1.288 0 01-1.29 1.282l-11.425-.018a1.286 1.286 0 01-1.283-1.287l.017-11.43A1.284 1.284 0 016.294 5.01l5.714.009a1 1 0 100-2L6.3 3.008h-.006A3.284 3.284 0 003.009 6.29l-.017 11.428a3.288 3.288 0 003.28 3.29l11.429.019a3.29 3.29 0 003.287-3.281L21 12.032a1 1 0 00-1-1.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.013 3.03l-4-.006a1 1 0 000 2h1.586L13.3 9.314a1 1 0 101.412 1.415l4.3-4.287v1.586a1 1 0 002 0l.006-4a.998.998 0 00-1.005-.998z"
  }));
}